import { Globe, ShoppingBag, LayoutDashboard, Server } from "lucide-react";
import { useI18n } from "../context/I18nContext";

export const Services = () => {
  const { t } = useI18n();
  const services = [
    { icon: Globe, title: t("services.vitrine_t"), desc: t("services.vitrine_d") },
    { icon: ShoppingBag, title: t("services.ecommerce_t"), desc: t("services.ecommerce_d") },
    { icon: LayoutDashboard, title: t("services.app_t"), desc: t("services.app_d") },
    { icon: Server, title: t("services.host_t"), desc: t("services.host_d") },
  ];
  return (
    <section id="services" data-testid="services-section" className="py-24 sm:py-32 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="text-xs font-semibold tracking-[0.3em] uppercase text-zinc-500 mb-4">
              {t("services.label")}
            </p>
            <h2 className="font-display text-3xl sm:text-5xl tracking-tighter max-w-2xl">
              {t("services.title_a")}
              <em className="italic text-zinc-400">{t("services.title_em")}</em>
              {t("services.title_b")}
            </h2>
          </div>
          <p className="text-sm text-zinc-400 max-w-md">{t("services.intro")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {services.map((s, idx) => {
            const Icon = s.icon;
            return (
              <article
                key={idx}
                data-testid={`service-card-${idx}`}
                className="group bg-zinc-950 p-8 hover:bg-zinc-900 transition-colors"
              >
                <div className="flex items-center justify-between mb-10">
                  <Icon size={22} strokeWidth={1.4} className="text-zinc-300" />
                  <span className="font-mono text-xs text-zinc-600">0{idx + 1}</span>
                </div>
                <h3 className="font-display text-2xl mb-3 tracking-tight">{s.title}</h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{s.desc}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
